// Main JavaScript file for your marketing agency website

(function() {
  'use strict';

  // Scroll Animation Observer
  const animationClasses = [
    '.animate-fade-up',
    '.animate-fade-down',
    '.animate-fade-left',
    '.animate-fade-right',
    '.animate-fade-in',
    '.animate-scale-up',
    '.animate-slide-up',
    '.animate-on-scroll',
    '.animate-stagger-item',
    '.animate-children'
  ];

  const initScrollAnimations = () => {
    const elements = document.querySelectorAll(animationClasses.join(','));

    if (!elements.length) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });

    elements.forEach(el => observer.observe(el));
  };

  // Expose globally for SvelteKit to call after navigation
  window.initScrollAnimations = initScrollAnimations;

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollAnimations);
  } else {
    initScrollAnimations();
  }

})();
